import { type GraphQLSingularResponse } from 'relay-runtime';

export const getTraceIdFromExtensions = ({
	extensions,
}: GraphQLSingularResponse): string | undefined => {
	if (
		extensions !== undefined &&
		extensions.gateway !== undefined &&
		extensions.gateway !== null &&
		typeof extensions.gateway.trace_id === 'string'
	) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return extensions.gateway.trace_id as string;
	}
	return undefined;
};
